// extracted by mini-css-extract-plugin
export var root = "F_vJ";
export var wrapper = "F_qg";
export var image = "F_vK d_w d_y d_W";
export var imageWithHeight = "F_vL";
export var crop = "F_vM";
export var round = "F_vN";
export var fixedHeight = "F_vP";